import React from 'react'
import Blog from '../pages/homepage/Blog'
import Faq from './Faq'

const AboutUs = () => {
  return (
    <>
      <div className="ax-hero-wrapper">
        <div className="ax-hero-content">
          <h1>Helping <span className="ax-highlight">BUSINESSES</span></h1>
          <h2>Grow Digitally</h2>
          <p>
            Choose AxeSell Today To Start Your E-Commerce Store Online And Build Your Brand.
          </p>
          <button className="ax-btn">Book a Call Now</button>
        </div>
        <div className="ax-sphere s-analytics"><span className="band black">Analytics</span></div>
        {/* <div class="ax-sphere s-templates"><span class="band teal">Templates</span></div> */}
        <div className="ax-sphere s-seo"><span className="band orange">SEO</span></div>
        <div className="ax-sphere s-payments"><span className="band white">Payments</span></div>
        <div className="ax-sphere s-graphics"><span className="band black">Graphics</span></div>
        {/* <div class="ax-sphere s-dashboard"><span class="band black">Dashboard</span></div> */}
        <div className="ax-sphere s-php"><span className="band teal">PHP</span></div>
        <div className="ax-sphere s-secure"><span className="band white">Secure</span></div>
        <div className="ax-sphere s-store"><span className="band orange">Store Front</span></div>
      </div>

<section className="ax-who-we-are">
  <div className="ax-grid-bg" />
  <div className="ax-content-wrapper">
    <div className="ax-text-box">
      <h2 className="ax-title">
        <span className="font-kalam">Who Are</span>
        <span className="font-arcade">  WE?</span>
      </h2>
      <p className="ax-description">
        AxeSell is a product of Axepert Exhibits PVT LTD. We have 11 years of working in the digital sphere providing
        a variety of IT Services inclusive of both design and development. Pioneer in customized user applications
        with finest and quality user experience thus deadlines on time and on track.
      </p>
    </div>
    <div className="ax-image-container">
      <div className="ax-shape-outline">
        <div className="ax-main-shape">
          <video autoPlay muted loop playsInline className="ax-video-element">
            <source src="/assets/images/video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  </div>
</section>

 <section className="ax-mission-section">
  <div className="ax-mission-container">
    <h2 className="ax-mission-title">
      <span className="text-orange italic">O</span><span className="text-orange">u</span><span className="text-orange italic">r </span>
      Mission
    </h2>
    <blockquote className="ax-mission-quote">
      "Transforming e-commerce dreams into stunning,<br /> ready-to-sell realities!"
    </blockquote>
  </div>
</section>



<section className="ax-leaders-parent">
  <div className="ax-leaders-wrapper">
    <div className="ax-container">
      <h2 className="ax-main-title">Meet <span className="ax-bold">THE</span> <span className="font-kalam text-orange">Leaders</span></h2>
      <div className="ax-team-grid">
        <div className="ax-leader-card">
          <div className="ax-leader-img"><img src="/assets/images/leader1.png" alt="Leader" /></div>
          <div className="ax-leader-info">
            <h4>Gustavo Franci</h4>
            <p>Chief Executive Officer</p>
          </div>
        </div>
        <div className="ax-leader-card">
          <div className="ax-leader-img"><img src="/assets/images/leader2.png" alt="Leader" /></div>
          <div className="ax-leader-info">
            <h4>Hanna Geidt</h4>
            <p>Chief Operating Officer</p>
          </div>
        </div>
        <div className="ax-leader-card">
          <div className="ax-leader-img"><img src="/assets/images/leader3.png" alt="Leader" /></div>
          <div className="ax-leader-info">
            <h4>Gustavo Franci</h4>
            <p>Founder &amp; CFO</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<Blog/>
<Faq/>

    </>
  )
}

export default AboutUs